import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import CompanyOverview from './companyOverview';
import HeadCount from './headCount';
import Locations from './locations';
import AcquisitionHistory from './acquisitionHistory';
import Subsidiaries from './subsidiaries';
import TickerAndStock from './tickerAndStock';
import TotalRevenue from './totalRevenue';
import Headquarters from './headquarters';
import MarketCap from './marketCap';
import EPS from './earningsPerShare';
import GrossProfit from './GrossProfit';
import Loading from '@components/loading';
import OperatingIncome from './OperatingIncome';
import NetIncome from './NetIncome';
import GeographicSegments from './geographicSegments';
import sga from './sga';
import CompanyHistory from './companyHistory';
import KeyContracts from './keyContracts';
import HeadcountSalesByCountry from './headcountSalesByCountry';
import { API } from '@service';

export const allRightComponent = {
  'Company Description': CompanyOverview,
  'Company History': CompanyHistory,
  'Employee Headcount': HeadCount,
  'Acquisition History': AcquisitionHistory,
  'Ticker and Stock Exchange': TickerAndStock,
  'Total Revenue': TotalRevenue,
  Headquarters,
  'Gross Profit': GrossProfit,
  'SG&A Expense': sga,
  'Operating Income': OperatingIncome,
  'Net Income': NetIncome,
  'Earnings Per Share': EPS,
  'Market Cap': MarketCap,
  Locations,
  'LE Subsidiaries': Subsidiaries,
  'Operational Footprint': Subsidiaries,
  'Geographic Segments': GeographicSegments,
  'Key Contacts': KeyContracts,
  'Headcount / Sales by Country': HeadcountSalesByCountry,
};

const resourcesUseGetFinancialDetails = [
  // 'operatingExpense',
  'grossProfit',
  'operatingIncome',
  'netIncome',
  'earningsPerShare',
];
const resourcesUseGetOtherDetails = {
  sub: 'subsidiary',
};
export const condition = {
  Timeline: [
    { name: 'LTM by Quarter', value: 'ltmForQuarter' },
    { name: 'LTM', value: 'ltm' },
    { name: '1Y by Quarter', value: '1yForQuarter' },
    { name: '1Y', value: '1y' },
    { name: '3Y', value: '3y' },
    // { name: '5Y', value: '5y' },
  ],
  Metrics: [
    { name: '-- None --', value: '' },
    { name: 'Sales Growth', value: 'sales Growth' },
    { name: 'Gross Margin', value: 'gross Margin' },
    { name: 'EPS', value: 'eps' },
    { name: 'Market Cap', value: 'market Cap' },
  ],
};

const AnalysisDetail = ({
  data,
  resourceId,
  resourceName,
  projectId,
  targetManualInputFlag,
  buyerManualInputFlag,
  isSingleCompany,
  refetch,
}) => {
  const [financialDetails, setFinancialDetails] = useState(data || {});
  const [otherDetails, setOtherDetails] = useState(data || {});

  const forceUpdateIds = useSelector(({ analysis }) => analysis.forceUpdateIds);
  // 匹配右侧组件，resourceName根据后端返回的字段在allRightComponent对象中加载对应的组件
  const RightComponent = allRightComponent[resourceName];

  const changeFinancialDetails = async (projectId, resourceId) => {
    const financialDetail = await API.getFinancialDetails(
      projectId,
      resourceId,
    );
    setFinancialDetails((preFinancialsDetail) => ({
      ...preFinancialsDetail,
      [resourceId]: financialDetail,
    }));
  };
  const changeOtherDetails = async (projectId, resourceId) => {
    if (otherDetails[resourceId]) {
      return;
    }
    const details = await API.getOtherDetails(
      projectId,
      resourcesUseGetOtherDetails[resourceId],
    );
    setOtherDetails((preOtherDetail) => ({
      ...preOtherDetail,
      [resourceId]: details,
    }));
  };
  useEffect(() => {
    if (resourcesUseGetFinancialDetails.includes(resourceId)) {
      changeFinancialDetails(projectId, resourceId);
    }

    if (Object.keys(resourcesUseGetOtherDetails).includes(resourceId)) {
      changeOtherDetails(projectId, resourceId);
    }
  }, [resourceId, forceUpdateIds]);

  if (!resourceId) {
    return <div />;
  }

  if (
    resourcesUseGetFinancialDetails.includes(resourceId) &&
    !financialDetails[resourceId]
  ) {
    return <Loading />;
  }

  if (
    Object.keys(resourcesUseGetOtherDetails).includes(resourceId) &&
    !otherDetails[resourceId]
  ) {
    return <Loading />;
  }

  return (
    RightComponent && (
      <RightComponent
        resourceId={resourceId}
        title={resourceName}
        data={data}
        others={financialDetails[resourceId] || otherDetails[resourceId]}
        condition={condition}
        buyerManualInputFlag={buyerManualInputFlag}
        targetManualInputFlag={targetManualInputFlag}
        isSingleCompany={isSingleCompany}
        refetch={refetch}
      />
    )
  );
};

export default React.memo(AnalysisDetail);
